import type { SortingState } from '@tanstack/react-table';

export const DEFAULT_SORTING: SortingState = [
  { id: 'expense_ratio', desc: false },
];
